import { render, staticRenderFns } from "./PsEventFooter.vue?vue&type=template&id=3d0beb60&scoped=true&"
import script from "./PsEventFooter.vue?vue&type=script&lang=js&"
export * from "./PsEventFooter.vue?vue&type=script&lang=js&"
import style0 from "./PsEventFooter.vue?vue&type=style&index=0&id=3d0beb60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0beb60",
  null
  
)

export default component.exports